import axios from 'axios';

import auth from '@/utils/auth';

import {

  GET_QUESTION,
  GET_QUESTION_ERROR,
  GET_QUESTION_SUCCESS,

  GET_QUESTIONS,
  GET_QUESTIONS_ERROR,
  GET_QUESTIONS_SUCCESS,

  // post question reply
  SAVE_QUESTION,
  SAVE_QUESTION_ERROR,
  SAVE_QUESTION_SUCCESS,

  // add question
  ADD_QUESTION,
  ADD_QUESTION_ERROR,
  ADD_QUESTION_SUCCESS,

  MAIN_ANSWER,
  MAIN_ANSWER_ERROR,
  MAIN_ANSWER_SUCCESS,

} from './constants';

export default {

  async [GET_QUESTION]({ commit }, questionID) {
    try {
      commit(GET_QUESTION);
      const response = await axios({
        url: `${process.env.API_URL}/api/users-questions/${questionID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_QUESTION_SUCCESS, response.data);
    } catch (err) {
      commit(GET_QUESTION_ERROR, err);
    }
  },

  async [GET_QUESTIONS]({ commit }, args) {
    try {
      commit(GET_QUESTIONS);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/users-questions`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          limit: args.limit || localStorage.pageLimit || '50',
          page: args.page || 0,
        },
      });
      commit(GET_QUESTIONS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_QUESTIONS_ERROR, err);
    }
  },

  async [SAVE_QUESTION]({ commit }, data) {
    try {
      commit(SAVE_QUESTION);
      let url = `${process.env.API_URL}/api/users-questions-reply`;
      let method = 'POST';
      if (data.coownerID) {
        url = `${url}/${data.coownerID}`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_QUESTION_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_QUESTION_ERROR, err);
    }
  },

  async [ADD_QUESTION]({ commit }, data) {
    try {
      commit(ADD_QUESTION);
      const url = `${process.env.API_URL}/api/users-questions`;
      const method = 'POST';
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(ADD_QUESTION_SUCCESS, response.data);
    } catch (err) {
      commit(ADD_QUESTION_ERROR, err);
    }
  },

  async [MAIN_ANSWER]({ commit }, data) {
    try {
      commit(MAIN_ANSWER);
      const url = `${process.env.API_URL}/api/answer-users-questions/${data.questionID}`;
      const method = 'PUT';
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(MAIN_ANSWER_SUCCESS, response.data);
    } catch (err) {
      commit(MAIN_ANSWER_ERROR, err);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Forum/actions.js